function contentTypeId(value) {
  if (value == null) return undefined;
  if (typeof value === 'number') return value;
  if (typeof value === 'object' && value !== null && 'id' in value) {
    const id = value.id;
    return typeof id === 'number' ? id : undefined;
  }
  return undefined;
}

export function mapApiProfileToPermissionDraft(profile) {
  const objectPermissions = (profile.object_level_permission || []).map((row, idx) => ({
    id: String(row.id ?? `obj-${idx}`),
    name: String(row.name ?? ''),
    view: Boolean(row.view),
    update: Boolean(row.update),
    create: Boolean(row.create),
    delete: Boolean(row.delete),
    viewAll: Boolean(row.view_all),
    updateAll: Boolean(row.update_all),
    content_type: contentTypeId(row.content_type),
    codename: row.codename != null ? String(row.codename) : undefined,
    description: row.description != null ? String(row.description) : undefined,
  }));

  const generalPermissions = (profile.general_user_permission || []).map((row, idx) => ({
    id: String(row.id ?? `gen-${idx}`),
    name: String(row.name ?? ''),
    isAllowed: Boolean(row.is_allowed ?? row.isAllowed),
    codename: row.codename != null ? String(row.codename) : undefined,
    description: row.description != null ? String(row.description) : undefined,
  }));

  return { objectPermissions, generalPermissions };
}
